import { FormItem, RadioGroupInput } from '@framework/form';
import React from 'react';
import { PdfVisibilityDirectiveKind } from './IPdfVisibilityDirective';

export interface IPdfVisibilityDirectiveConfigComponentProps {
  name: string;
}

export function PdfVisibilityDirectiveConfigComponent(
  props: IPdfVisibilityDirectiveConfigComponentProps,
) {
  const { name } = props;
  return (
    <FormItem
      name={`${name}.visibility`}
      label="Visibilità nella sezione"
      help="Indica se il campo deve apparire solo nel PDF, solo in compilazione o in entrambi."
      style={{ marginBottom: 48 }}
    >
      <RadioGroupInput
        name={`${name}.visibility`}
        options={[
          { label: 'Entrambi', value: PdfVisibilityDirectiveKind.ALL },
          {
            label: 'Visibile solo nel PDF',
            value: PdfVisibilityDirectiveKind.PDF,
          },
          {
            label: 'Visibile solo in compilazione',
            value: PdfVisibilityDirectiveKind.COMPILATION,
          },
        ]}
      />
    </FormItem>
  );
}
